import { useTranslation } from "react-i18next"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useError } from "../../context/useErrorContext"
import { ERequestType } from "../../Enum/ERequestType"
import { GetRequest, PostRequest } from "../../services/ApiClientService"

export interface TableSelfServiceSession {
  token: string
  tableId: number
  tableNumber: number
  canCreateOrders: boolean
}

export const usePublicTableSelfService = () => {
  const { t } = useTranslation("tableSelfService")
  const { setError } = useError()

  const storeSession = (session: TableSelfServiceSession) => {
    localStorage.setItem(API_ROUTES.TOKEN_TABLE_SELF_SERVICE, session.token)
  }

  const handleValidateStoredSession = async (restaurantSlug: string) => {
    if (!localStorage.getItem(API_ROUTES.TOKEN_TABLE_SELF_SERVICE)) {
      return null
    }

    try {
      const response = await GetRequest<TableSelfServiceSession>(
        API_ROUTES.TABLE.GET_SELF_SERVICE_SESSION(restaurantSlug),
        ERequestType.TableSelfService,
      )

      if (!response.success || !response.data) {
        localStorage.removeItem(API_ROUTES.TOKEN_TABLE_SELF_SERVICE)
        return null
      }

      storeSession(response.data)
      return response.data
    } catch {
      localStorage.removeItem(API_ROUTES.TOKEN_TABLE_SELF_SERVICE)
      return null
    }
  }

  const handleActivateTablet = async (restaurantSlug: string, activationCode: string) => {
    try {
      const response = await PostRequest<TableSelfServiceSession>(
        API_ROUTES.TABLE.ACTIVATE_SELF_SERVICE(restaurantSlug),
        { activationCode },
      )

      if (!response.success || !response.data) {
        throw new Error(response.message)
      }

      storeSession(response.data)
      return response.data
    } catch (error) {
      setError(t("error_title"), error instanceof Error ? error.message : t("activation_error"))
      return null
    }
  }

  return {
    handleActivateTablet,
    handleValidateStoredSession,
  }
}

